import React, { useState, Fragment, useEffect } from "react";
import parse from "html-react-parser";
const TRANSLATE_URL = process.env.REACT_APP_CHAT_API + "/google-translate";
export default function useTranslate(input, lang, enabled = false) {
    const [translatedText, setTranslatedText] = useState(input || '');

    useEffect(() => {
        if (!enabled || !input || !lang) {
            setTranslatedText(input || '');
            return;
        }

        fetch(TRANSLATE_URL, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                q: input,
                target: lang,
            }),
        })
            .then((res) => res.json())
            .then((data) => {
                setTranslatedText(data?.output || input);
            })
            .catch(() => {
                setTranslatedText(input);
            });
    }, [input, lang, enabled]);

    return translatedText;
}